import { set } from '@/utils/vuex'

export default {
  // Timers
  setCurrentTimestamp: set('currentTimestamp'),
  setFetchedTimestamp: set('fetchedTimestamp'),
  setIntervalId: set('intervalId'),

  // Data
  setLoading: set('loading'),

  // Display
  selectSpan: set('selectedSpan'),

  // Data
  setArea: set('area'),
  setIsDelivery: set('isDelivery'),
  setLastUpdatedAt: set('lastUpdatedAt'),
  setTankInfo: set('tankInfo'),
  setYearly: set('yearly'),
  setYesterdayData: set('yesterdayData'),
  setWeeklyArray: set('weeklyArray'),
  setMonthlyArray: set('monthlyArray'),
  setWeatherData: set('weatherData'),
  setChartLoader: set('chartLoader'),
  setWeatherInfoLoader: set('weatherInfoLoader')
}
